import AuditsTask from "./AuditsTask";

export default AuditsTask;